'use client'
import { Providers } from "../utils";
import "./global.css";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { useGlobalStore } from "@/zustand/initStore";
import ChangelogModal from "@/components/ChangelogModal";
import { isSuperadminHost, isDevBypassHost } from "@/lib/superadminHost";
import {
  applyBrandColors,
  applyFavicon,
  fetchTenantConfig,
  toCmsConfig,
} from "@/lib/tenantConfig";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [domain, setDomain] = useState<string>("");
  const { config, setConfig } = useGlobalStore();
  console.log('Version 1.3.0 ');
  useEffect(() => {
    if (typeof window !== "undefined") {
      const host = window.location.hostname;
      setDomain(host);
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isSuperadminHost(window.location.hostname)) {
      document.documentElement.style.setProperty('--primary-color', '#10b981');
      document.documentElement.style.setProperty('--secondary-color', '#0f172a');
      return;
    }
    const host = window.location.host;
    fetchTenantConfig(host).then((resolved) => {
      if (resolved) {
        const mapped = toCmsConfig(resolved);
        setConfig(mapped as any);
        applyBrandColors(resolved);
        applyFavicon(resolved.favicon);
      } else if (!isDevBypassHost(host)) {
        window.location.assign("https://rezervator.ba");
      }
    });
  }, [setConfig]);

  return (
    <html id='root' lang="en">
      <head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
        {config?.favicon && (
          <link rel="icon" href={config.favicon as unknown as string} />
        )}
      </head>
      <body data-domain={domain} className="overflow-y-auto">
        <Providers>
          {children}
          {!isSuperadminHost(domain) && <ChangelogModal />}
        </Providers>
      </body>
    </html>
  );
}
